export default __webpack_public_path__ + "static/media/bids2.dcf1b08c.png";